import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { TESTIMONIALS } from '@/data/siteData';
import { Star, Quote } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  const { lang } = useLanguage();

  return (
    <div className="bg-white rounded-2xl p-8 shadow-sm border border-stone-100 hover:border-[#D4AF37]/30 transition-all duration-300">
      {/* Quote Icon */}
      <div className="w-12 h-12 bg-[#1a365d] rounded-full flex items-center justify-center mb-6">
        <Quote className="w-5 h-5 text-[#D4AF37]" />
      </div>

      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
        ))}
      </div>

      {/* Text */}
      <p className="text-slate-600 mb-6 leading-relaxed italic">
        "{lang === 'en' ? testimonial.textEn : testimonial.text}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-gradient-to-br from-[#1a365d] to-[#2d4a7c] rounded-full flex items-center justify-center">
          <span className="text-[#D4AF37] font-semibold text-sm">
            {testimonial.name.split(' ').map(n => n[0]).join('')}
          </span>
        </div>
        <div>
          <p className="font-semibold text-[#1a365d]">{testimonial.name}</p>
          <p className="text-sm text-slate-500">
            {testimonial.location} • {lang === 'en' ? testimonial.serviceEn : testimonial.service}
          </p>
        </div>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-semibold text-sm tracking-widest uppercase mb-4">
            {t('Témoignages', 'Testimonials')}
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1a365d] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('Ce Que Disent Nos Clients', 'What Our Clients Say')}
          </h2>
          <p className="text-slate-600 text-lg">
            {t("Clients satisfaits sur la Côte d'Azur", 'Satisfied clients on the French Riviera')}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#D4AF37] to-[#C9A227] mx-auto mt-6 rounded-full" />
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {TESTIMONIALS.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
